import { search } from "../../../BaseRepositoryComponents";

const url = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant`;

export async function findClientsContractsResumeV3({
  page = 1,
  perPage = 10,
  paginate = 1,
  filters = {
    contractType: "",
    document: "",
    companyId: null,
    name: "",
  },
}) {
  const searchParams = new URLSearchParams(window.location.search);

  const path = new URL(`${url}/contrato/customer/summary`);

  const headers = new Headers();
  const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
  headers.append("Authorization", token);
  headers.append("content-type", "application/json");

  Object.entries(filters).forEach(([name, value]) => {
    if (value) path.searchParams.append(`${name}`, value);
  });
  path.searchParams.append("perPage", perPage);
  path.searchParams.append("page", page);
  path.searchParams.append("paginate", paginate);

  return search(decodeURIComponent(path), "GET", headers);
}

export async function findProposal({ id }) {
  const searchParams = new URLSearchParams(window.location.search);

  const path = new URL(`${url}/qyon/contract/review/${id}`);

  const headers = new Headers();
  const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
  headers.append("Authorization", token);
  headers.append("content-type", "application/json");

  return search(decodeURIComponent(path), "GET", headers);
}

export const getBillingRules = async () => {
  const searchParams = new URLSearchParams(window.location.search);

  const path = new URL(`${url}/billing-rule/managment-screen`);

  const headers = new Headers();
  const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
  headers.append("Authorization", token);
  headers.append("content-type", "application/json");

  return search(decodeURIComponent(path), "GET", headers);
};
